import React, { useState, useEffect } from 'react';
import './ListeMarkers.css';
import ConversationService from '../../../services/ConversationService';
import ConversationMarker from '../../ConversationMarker/ConversationMarker';
import '../../ConversationDetailsModal/ConversationModalFollowUp/ConversationModalFollowUp.css';
import { setStorageParamForCurrentCompany, getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';


const ListMarkers = ({ updateMarkersValues,resetMarkers }) => {

    const [listCheckedMarkerList, setListCheckedMarkerList] = useState([]);
    const { getMarkers } = ConversationService;
    const [markersList, setMarkersList] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const getAllMarkers = async () => {
        let [response, error] = await getMarkers();
        if (error !== null) {
            console.log(error);
            return;
        }
        let markers = getStorageParamForCurrentCompany('conversation_filters')?.markers?.split(","); // un state surtout pour actualiser visuellement les dropdown quand on refresh
        setListCheckedMarkerList(markers ? markers.map(id => { return { id: id } }) : [])
        setMarkersList(response);
    }

    useEffect(() => {
        if (markersList != []){
            setListCheckedMarkerList([]);
        }
    },[resetMarkers])
    
    useEffect(() => {
        getAllMarkers();
    }, [])


    const checkMarkerList = (_marker) => {
        setIsChecked(!isChecked);

        let resultList = [...listCheckedMarkerList];

        let index = resultList.findIndex((item) => item.id == _marker.id);

        if (index === -1) {
            resultList.push(_marker);
        } else {
            resultList.splice(index, 1);
        }

        setListCheckedMarkerList(resultList);
        let markerIdsTextList = resultList.filter(res => res.id != "").map((marker) => marker.id).join(',');
        updateMarkersValues(markerIdsTextList, resultList);
    };

    return (
        <>
            {Array.isArray(markersList) && markersList.length > 0 ?
                <div className="markers_list_channel_filter">
                    {markersList.map((marker, i) => {
                        return (
                            <ConversationMarker marker={marker} mode={1} icon={listCheckedMarkerList.some(item => item.id == marker.id) ? "fas fa-check-circle" : "fas fa-plus-circle"} key={i} onClick={() => checkMarkerList(marker)} />
                        )
                    })}
                </div>

                :
                <div className='conversation_follow_up_no_marker_message' style={{ width: "85%" }}>There are no more markers available</div>
            }
        </>
    );
};

export default ListMarkers;